// @flow
import WorklogPlaceholder from './WorklogPlaceholder';

export default WorklogPlaceholder;
